// src/data/productsData.js
// Saara product data yahan se aata hai — naya product add karna ho to
// bas is array mein ek object add kar dein, kahin aur code chhedne ki zaroorat nahi.

import aImage from "../assets/images/a.png";
import bestsellImage from "../assets/images/bestsell.png";

export const PRODUCTS = [
  {
    id: "serum",
    category: "SKINCARE / SERUMS",
    name: "Ultimate 4-in-1 Skin Revitalizing Serum",
    price: 2500,
    currency: "Rs.",
    badge: "BEST-SELLER",
    newBadge: "NEW IN",
    status: "available",
    image: bestsellImage,
    gallery: [bestsellImage, aImage],
    strengths: [
      { label: "30 mL", available: true },
      { label: "50 mL", available: false },
    ],
    benefits: [
      "Infused with Vitamin C for a radiant glow",
      "Anti-aging benefits",
      "Provides deep hydration",
      "Helps promote a more even skin tone",
    ],
    ingredients:
      "Sea Buckthorn Extract, Licorice Extract, Cucumber Extract, Tasmannia Extract, 3-O-Ethyl Ascorbic Acid, Arginine, Alpha-Arbutin, Kojic Acid, Ceramide, Lactic Acid, Niacinamide, and Hyaluronic Acid.",
  },
  {
    id: "facewash",
    category: "SKINCARE / CLEANSERS",
    name: "Whitening Facewash",
    price: null,
    currency: "Rs.",
    badge: "COMING SOON",
    status: "coming-soon",
    image: "/facewash.png",
    gallery: [],
    strengths: [],
    benefits: [],
    ingredients: "",
  },
  {
    id: "haircare",
    category: "HAIRCARE / SERUMS",
    name: "Haircare Serum",
    price: null,
    currency: "Rs.",
    badge: "COMING SOON",
    status: "coming-soon",
    image: "/haircare.png",
    gallery: [],
    strengths: [],
    benefits: [],
    ingredients: "",
  },
];
